import * as yup from 'yup';
import moment from 'moment';
import StorageService from '../../services/StorageService';

const Storage = new StorageService();
export const malattiaSchema = yup.object({
  product: yup.string().required(),
  source: yup.string().required(),
  name: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci il nome!')
    .matches(/^[a-zA-Z ]+$/, 'Non sono ammessi numeri o caratteri speciali!'),
  surname: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci il cognome!')
    .matches(/^[a-zA-Z ]+$/, 'Non sono ammessi numeri o caratteri speciali!'),
  gender: yup.string().required('Il campo è obbligatorio. Seleziona genere!'),
  date_of_birth: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona data di nascita!')
    .test(
      'valid-date',
      "La data di nascita non è valida. L'età deve essere tra 18 e 65 anni.",
      (value) => {
        if (!value) return false;

        const birthDate = moment(value, 'YYYY-MM-DD', true);
        if (!birthDate.isValid()) return false;

        const today = moment();
        const age = today.year() - birthDate.year(); // <-- YEAR ONLY

        return age >= 18 && age <= 65;
      },
    ),

  commune_of_birth_code: yup
    .string()
    .nullable()
    .when(['gender', 'born_abroad'], ([gender, born_abroad], schema) => (gender !== 'G'
      ? born_abroad === false
        ? schema.required(
          'Il campo è obbligatorio. Inserisci luogo di nascita del contraente!',
        )
        : schema
      : schema)),
  phone: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci numero di telefono!')
    .matches(/^[3]{1}[0-9]{8,9}$/, 'Il numero non e corretto'),
  email: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci Email!')
    .email('Deve essere un email valido! Rimouvi spazi vuoti!')
    .test('brokerEmail', 'Non puoi impostare la tua email', (value) => value !== Storage.getUser().email),
  residence_commune_code: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona provincia di residenza!'),
  province_of_birth_code: yup
    .string()
    .nullable()
    .when(['gender', 'born_abroad'], ([gender, born_abroad], schema) => (gender !== 'G'
      ? born_abroad === false
        ? schema.required(
          'Il campo è obbligatorio. Inserisci luogo di nascita del contraente!',
        )
        : schema
      : schema)),
  born_abroad: yup
    .boolean()
    .required('Il campo è obbligatorio. Seleziona se nato al estero!'),
  country_of_birth_code: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona il stato estero!'),
  address: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci indirizzo!'),
  house_number: yup.string().required('Il campo è obbligatorio.').matches(/^[1-9]\d*([a-zA-Z]|\/(\d+[a-zA-Z]?|[a-zA-Z]+))?$/, 'Il numero deve essere maggiore di 0.'),
  postal_code: yup
    .string()
    .required('Il campo è obbligatorio. Inserisci codice postale!')
    .matches(/^[0-9]{5}$/, 'Il codice postale non e coretto'),
  fiscal_code: yup.string().nullable(),
  residence_province_code: yup
    .string()
    .required('Il campo è obbligatorio. Seleziona provincia di residenza!'),
  existing_customer: yup.boolean(),
  active_customer_id: yup.number().nullable(),
  policy_effective_date: yup
    .date()
    .typeError('Il campo è obbligatorio. Seleziona data decorrenza!')
    .required('Il campo è obbligatorio. Seleziona data decorrenza!')
    .min(
      new Date(moment().subtract(1, 'day').format('YYYY-MM-DD')),
      'La data è nel passato',
    )
    .max(
      new Date(moment().add(30, 'day').format('YYYY-MM-DD')),
      'La data è nel futuro',
    ),
  privacies: yup.array(yup.number()),
  invalidita_permanente_inabilita_temporanea: yup.string().required('Il campo è obbligatorio'),
  infortuni_subiti: yup.string().required('Il campo è obbligatorio'),
  rifiuto_o_condizioni_speciali_polizza: yup.string().required('Il campo è obbligatorio'),
  polizza_malattia_annullata: yup.string().required('Il campo è obbligatorio'),
  familiare_deceduto_prima_55_malattia: yup.string().required('Il campo è obbligatorio'),
  familiari_primo_grado_casi_malattie_ereditarie: yup.string().required('Il campo è obbligatorio'),
  imperfezioni_fisiche_o_disturbi_funizonali: yup.string().required('Il campo è obbligatorio'),
  uso_sostanze_stupefacenti_o_abuso_alcolici: yup.string().required('Il campo è obbligatorio'),
  fuma_piu_20_sigarette_al_giorno: yup.string().required('Il campo è obbligatorio'),
  malattie_ricovero_ospedaliero: yup.string().required('Il campo è obbligatorio'),
  disturbi_ricorrenti_malattia: yup.string().required('Il campo è obbligatorio'),
  infortuni_ricovero_postumi_invalidanti: yup.string().required('Il campo è obbligatorio'),
  farmaci_terapeutici_continuativi: yup.string().required('Il campo è obbligatorio'),
  terapie_emotrasfusioni_chemioterapia_radioterapia: yup.string().required('Il campo è obbligatorio'),
  malattie_infezioni_controlli_periodici: yup.string().required('Il campo è obbligatorio'),
  pressione_arteriosa_inferiore_140_90: yup.string().required('Il campo è obbligatorio'),
  colesterolo_totale: yup.string().required('Il campo è obbligatorio'),
  diabete_mellito: yup.string().required('Il campo è obbligatorio'),
  altre_assicurazioni_stessi_rischi: yup.string().required('Il campo è obbligatorio'),

});

export const answersMalattiaFieldsBySteps = [
  [
    'gender',
    'date_of_birth',
    'commune_of_birth_code',
    'province_of_birth_code',
    'born_abroad',
    'residence_commune_code',
    'residence_province_code',
    'postal_code',
    'house_number',
    'address',
    'name',
    'surname',
    'email',
    'phone',
    'policy_effective_date',
    'fiscal_code',
    'country_of_birth_code',
  ],
  [
    'invalidita_permanente_inabilita_temporanea',
    'infortuni_subiti',
    'rifiuto_o_condizioni_speciali_polizza',
    'polizza_malattia_annullata',
    'familiare_deceduto_prima_55_malattia',
    'familiari_primo_grado_casi_malattie_ereditarie',
    'imperfezioni_fisiche_o_disturbi_funizonali',
    'uso_sostanze_stupefacenti_o_abuso_alcolici',
    'fuma_piu_20_sigarette_al_giorno',
    'malattie_ricovero_ospedaliero',
    'disturbi_ricorrenti_malattia',
    'infortuni_ricovero_postumi_invalidanti',
    'farmaci_terapeutici_continuativi',
    'terapie_emotrasfusioni_chemioterapia_radioterapia',
    'malattie_infezioni_controlli_periodici',
    'pressione_arteriosa_inferiore_140_90',
    'colesterolo_totale',
    'diabete_mellito',
    'altre_assicurazioni_stessi_rischi',
  ],
];
